import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

export default {
  ...zhLocale,
  'button': {
    'search': '搜索',
    'confirm': '确定',
    'cancel': '取消',
    'delete': '删除',
    'submit': '提交',
    'tips': '提示',
    'uploadimage': '上传图片',
    'clicktoupload': '点击上传',
    'deleteimage': '删除图片',
    'save': '保存'
  },
  'sureToDeleteit': '你确定要删除吗?',
  'advance': '预售'
}


// WEBPACK FOOTER //
// ./resources/js/lib/i18n/zh/common.js